module.exports = __webpack_public_path__ + "img/foot_img2.bd8b240d.png";